<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="$refs.table.reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="orderCode" label="订单编号：">
        <order-drop v-model="queryForm.orderCode"></order-drop>
      </el-form-item>
      <el-form-item prop="productCode" label="品番号：">
        <el-input v-model="queryForm.productCode" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="品名：">
        <el-input v-model="queryForm.productName" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSkuCode" label="SKU：">
        <el-input v-model="queryForm.productSkuCode" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色(品番)：">
        <el-input v-model="queryForm.productColor" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格(品番)：">
        <el-input v-model="queryForm.productSize" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="materialName" label="物料名称：">
        <el-input v-model="queryForm.materialName" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="materialColor" label="颜色（物料）：">
        <el-input v-model="queryForm.materialColor" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="materialSize" label="规格（物料）：">
        <el-input v-model="queryForm.materialSize" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="materialAttr1" label="幅宽：">
        <el-input v-model="queryForm.materialAttr1" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="materialAttr2" label="克重：">
        <el-input v-model="queryForm.materialAttr2" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="margin-bottom: 0;justify-content: left;">
      <el-button type="warning" @click="$refs.bomUpload.init()" v-if="$hasPermission('order:bom:import')" size="mini"
                 icon="el-icon-upload2">
        批量导入单耗
      </el-button>
      <el-button type="danger" @click="doBatchDelete" v-if="$hasPermission('erp:bom:del')" size="mini"
                 icon="el-icon-delete">
        批量删除
      </el-button>
      <el-button type="primary" @click="showSetCount" v-if="$hasPermission('erp:bom:count')" size="mini"
                 icon="el-icon-delete">
        批量设置单耗
      </el-button>
    </div>
    <SweetTable ref="table" url="/erp/bom/page" delete-url="/erp/bom" :selection="true" :query-form="queryForm"
                :before-table-binding="beforeTableBinding">
      <el-table-column prop="orderCode" label="订单编号 " header-align="center"
                       align="center" min-width="160"></el-table-column>
      <el-table-column label="品番" header-align="center">
        <el-table-column prop="product.sysCode" label="品番系统编号" header-align="center"
                         align="center" width="120"></el-table-column>
        <el-table-column prop="product.code" label="品番号" header-align="center"
                         align="center" min-width="160"></el-table-column>
        <el-table-column prop="product.skuCode" label="SKU" header-align="center"
                         align="center" min-width="160"></el-table-column>
        <el-table-column prop="product.name" label="品名" header-align="center"
                         align="center" min-width="90"></el-table-column>
        <el-table-column prop="product.color" label="颜色(品番)" header-align="center"
                         align="center" min-width="90">
        </el-table-column>
        <el-table-column prop="product.size" label="规格(品番)" header-align="center"
                         align="center" min-width="90">
        </el-table-column>
      </el-table-column>
      <el-table-column label="物料" header-align="center">
        <el-table-column prop="material.sysCode" width="120" label="物料系统编号" header-align="center"
                         align="center" min-width="160"></el-table-column>
        <el-table-column prop="material.name" label="物料名称" header-align="center"
                         align="center" min-width="160"></el-table-column>
        <el-table-column prop="material.color" label="颜色（物料）" header-align="center"
                         align="center" min-width="160"></el-table-column>

        <el-table-column prop="material.size" label="规格（物料）" header-align="center"
                         align="center" min-width="90">
        </el-table-column>
        <el-table-column prop="material.attr1" label="幅宽" header-align="center"
                         align="center" min-width="90">
        </el-table-column>
        <el-table-column prop="material.attr2" label="克重" header-align="center"
                         align="center" min-width="90">
        </el-table-column>
      </el-table-column>
      <el-table-column prop="count" label="计划单耗" header-align="center"
                       align="center" width="90"></el-table-column>
      <el-table-column label="操作" header-align="center"
                       align="center" width="100" fixed="right">
        <template #default="{row}">
          <el-button type="text" @click="showSaveDialog(row)">修改</el-button>
          <el-button type="text" @click="doDel(row)">删除</el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <SaveDialog ref="SaveDialog" @change="getDataList"></SaveDialog>
    <SetCount ref="SetCount" @change="()=>{this.getDataList();this.clearSelection()}"></SetCount>
    <common-upload
        ref="bomUpload"
        @success="getDataList"
        uploadUrl="/erp/bom/import/batch"
        templateUrl="/static/template/单耗批量导入模板.xlsx"
        title="单耗批量导入"
    ></common-upload>
  </div>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import SaveDialog from './save.vue'
import SetCount from '@/views/modules/erp/bom/SetCount.vue'
export default {
  components: { SaveDialog,SetCount },
  mixins: [SweetTable],
  data () {
    return {
      queryForm: {
        orderCode: '',
        productCode: '',
        productName: '',
        productSkuCode: '',
        productColor: '',
        productSize: '',
        materialName: '',
        materialColor: '',
        materialSize: '',
        materialAttr1: '',
        materialAttr2: ''
      },
    }
  },
  watch: {},
  computed: {},
  activated () {
    this.$nextTick(() => {
      this.$refs.table.reload()
    })
  },
  methods: {
    doDel (row) {
      this.$confirm(`是否要删除单耗【${row.name} ${row.color} ${row.size} ${row.attr1} ${row.attr2}】？`, '操作提示').then(() => {
        this.$api.delete(`/erp/bom`, { data: [row.id] }).then(res => {
          this.$refs.table.getDataList()
          this.$message.success('删除成功')
        })
      })
    },
    //显示单耗修改弹窗
    showSaveDialog (row) {
      this.$refs.SaveDialog.product=row.product
      this.$refs.SaveDialog.parentId=row.agreementDetailId
      this.$refs.SaveDialog.init()
    },
    //显示批量设置单耗弹窗
    showSetCount(){
      let selDatas=this.$refs.table.dataListSelections
      if(selDatas.length===0){
        return this.$message.error('请选择要设置单耗的物料')
      }
      this.$refs.SetCount.dataForm.bomIds=selDatas.map(item=>item.id)
      this.$refs.SetCount.init()
    },
    beforeTableBinding (dataList) {
      dataList.forEach(item => {

      })
    },

  }
}
</script>

<style scoped>
</style>
